module.exports = __webpack_public_path__ + "static/media/otp.e03586bc.jpg";